module.exports = __webpack_public_path__ + "static/media/appstore.cdb12f48.svg";